import { ApiStatus } from './types/api-status';
import { State } from './types/resources/State';

const initialState: State = {
  certificate: {
    certificates: {
      certificates: [],
      total: 0
    },
    replaceCertificateStatus: ApiStatus.NotExecuted,
    certificatesLoading: false,
    selectedCertificate: {
      detail: {
        vmid: '',
        alias: '',
        key: '',
        certChain: '',
        leafCert: '',
        validations: [],
        validity: {
          period: '',
          expiresOn: '',
          issuedOn: '',
          healthy: false
        },
        certInfo: {
          subject: '',
          issuer: '',
          san: '',
          algorithm: '',
          keyAlgorithm: '',
          keyLength: '',
          sha256: '',
          sha1: ''
        }
      },
      references: {
        environments: [],
        containers: []
      },
      selectedCertificateLoading: false,
      overview: {
        vmid: '7',
        subject: '',
        issuer: '',
        algorithm: '',
        sha1: '',
        alias: '',
        healthy: false,
        referenced: false
      },
      modal: false
    }
  },
  license: {
    licenses: [],
    sysUsageStatus: ApiStatus.NotExecuted,
    licensesLoading: false,
    syncUsageRequestId: '',
    selectedLicense: {
      detail: {
        vmid: '',
        alias: '',
        key: '',
        connected: false,
        description: '',
        quantity: 0,
        unit: '',
        type: '',
        account: '',
        edition: '',
        expiresOn: '',
        status: '',
        onPremAllocation: '',
        startDateH: '',
        endDateH: '',
        casId: '',
        lintId: '',
        healthy: false,
        validations: []
      },
      references: {
        environments: [],
        containers: []
      },
      selectedLicenseLoading: false,
      overview: {
        vmid: '',
        key: '',
        alias: '',
        description: '',
        quantity: 0,
        account: '',
        expiresOn: '',
        healthy: false,
        expired: false,
        connected: false,
        type: '',
        validations: []
      },
      modal: false
    }
  },
  password: {
    passwords: {
      passwords: [],
      total: 0
    },
    passwordsLoading: false,
    selectedPassword: {
      detail: {
        vmid: '',
        alias: '',
        userName: '',
        password: '',
        passwordDescription: '',
        createdOn: 0,
        lastUpdatedOn: 0
      },
      selectedPasswordLoading: false
    }
  }
};

export default initialState;
